export const PRETTY_GEOM_TYPES = [
  'N/A',
  'State',
  'Federal Division',
  'SA1',
  'LGA',
  'State Lower District',
  'State Upper District',
  'Local Government Ward',
  'Branch',
  'Postcode',
  'Locality',
  'Upper House District',
];

export const MANUAL_PLACEMENT_TOOLTIP =
  "Manual placements are often temporary and are added where a person’s primary address is outside an area but they need to be visible to users that have access restricted to that location eg. where they have registered to an event or have opted-in to your field campaign.";
